import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom"; 
/*
    This function will handle the login redirect from an invite link.
    Store the token in local storage so that the login page can access and send it if needed.
*/
function Invite() {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    useEffect(() => {
        const token = searchParams.get("token");
        console.log(token);
        localStorage.setItem("inviteToken", token);
        navigate("/auth/login");
    })
}

export default Invite;